import './styles/index.scss';
import { useSelector } from 'react-redux';
import { RootState } from '../shared/redux/store';
import { Pages } from '../shared/redux/pages/types';
import Loading from '../pages/Loading/Loading';
import Start from '../pages/Start/Start';
import Onboarding from '../pages/Onboarding/Onboarding';
import Game from '../pages/Game/Game';
import Final from '../pages/Final/Final';
import { Howl } from 'howler';
import bgOnbMp3 from '../shared/assets/sound/bg_onboarding.mp3';
import bgGameMp3 from '../shared/assets/sound/bg_game.mp3';
import { useEffect, useMemo, useState } from 'react';

function App() {
  const { currentPage, endGame } = useSelector((state: RootState) => state.pages);
  const isSound = useSelector((state: RootState) => state.sound.isSound);

  const [bgSound, setBgSound] = useState<Howl>();

  useEffect(() => {
    console.log('сработал useEffect звука');
    if (isSound) {
      bgSound?.play();
    } else {
      bgSound?.pause();
    }
  }, [isSound, bgSound]);

  useEffect(() => {
    const soundOnbBg = new Howl({
      src: [bgOnbMp3],
      loop: true,
    });

    const soundGameBg = new Howl({
      src: [bgGameMp3],
      loop: true,
    });

    if (currentPage === Pages.GAME && !endGame) {
      console.log('Страница Game');
      bgSound?.pause();
      setBgSound(soundGameBg);
    } else if (currentPage === Pages.FINAL || endGame) {
      bgSound?.pause();
    } else if (currentPage === Pages.LOADING) {
      bgSound?.pause();
      setBgSound(soundOnbBg);
    }
  }, [currentPage, endGame]);

  return (
    <div className="App">
      {currentPage === Pages.LOADING && <Loading />}
      {currentPage === Pages.START && <Start />}
      {currentPage === Pages.ONBOARDING && <Onboarding />}
      {currentPage === Pages.GAME && <Game />}
      {currentPage === Pages.FINAL && <Final />}
    </div>
  );
}

export default App;
